// Module-specific navigation labels only. Chrome bits (menu/sidebar/header/
// userPanel/version + admin/superAdmin/account/security/seed nav) live in
// `core-fe-lib/components-shadcn/i18n/en-US/layout.ts` and are merged in
// via `./index.ts`.
export default {
  navigation: {
    aiemployee: {
      employees: {
        title: "Employees",
        caption: "Build and tune the AI workforce",
      },
      dashboard: {
        title: "Dashboard",
        caption: "Cost and usage across your AI workforce",
      },
    },
    care: {
      title: "Care",
      caption: "Care",
      circles: {
        title: "Circles",
        caption: "Select/Manage Circles",
      },
    },
    // Per-module seed block. SeedDataPanel interpolates the `module`
    // prop into `layout.navigation.<module>.seed.<kind>.<success|error>`,
    // and the care SeedPage passes `module="Care"` (capital), so the
    // strings must live under this exact casing.
    Care: {
      seed: {
        reference: {
          success: "Care reference data initialized successfully",
          error: "Failed to initialize Care reference data",
        },
        sample: {
          success: "Care sample data initialized successfully",
          error: "Failed to initialize Care sample data",
        },
      },
    },
    cron: {
      title: "Cron",
      caption: "Cron Jobs",
      jobAuditLogs: {
        title: "Job Audit Logs",
        caption: "Manage Job Audit Logs",
      },
      jobs: {
        title: "Jobs",
        caption: "Manage Jobs",
      },
      registeredJobs: {
        title: "Registered Jobs",
        caption: "Manage Registered Jobs",
      },
    },
    social: {
      title: "Social",
      caption: "Social media automation",
      sources: {
        title: "Sources",
        caption: "Manage Sources",
      },
      posts: {
        title: "Publications",
        caption: "Manage social media posts",
      },
      summaries: {
        title: "Summaries",
        caption: "Manage content summaries",
      },
      savedArticles: {
        title: "Saved Articles",
        caption: "Manage source articles",
      },
      searchArticles: {
        title: "Search Articles",
        caption: "Fetch articles",
      },
      settings: {
        title: "Social Media Settings",
        caption: "Manage connections",
      },
      source: {
        title: "Source",
        caption: "Manage Source",
      },
      seed: {
        reference: {
          success: "LinkedIn prompts seeded successfully",
          error: "Failed to seed LinkedIn prompts",
        },
      },
    },
    kanban: {
      title: "Kanban",
      caption: "Optimize your projects and resources",
      tasks: {
        title: "Tasks",
        caption: "At your own pace",
      },
      columns: {
        title: "Columns",
        caption: "At your own pace",
      },
    },
    contacts: {
      title: "Contacts",
      caption: "Exchange with your contacts",
      messages: {
        title: "Messages",
        caption: "At your own pace",
      },
    },
    automation: {
      title: "Automation",
      caption: "AI Automation tools",
      prompts: {
        title: "Prompts",
        caption: "Manage prompts",
      },
    },
    operations: {
      title: "Operations",
      caption: "Cron, queues, secrets, pipelines, automation",
    },
    outbox: {
      title: "Outbox",
      caption: "Outbound webhook queue",
      messages: {
        title: "Messages",
        caption: "Outbound webhook queue",
      },
    },
    secret: {
      title: "Secrets",
      caption: "API keys & integrations",
      manage: {
        title: "Manage",
        caption: "API keys shared across modules",
      },
    },
    document: {
      title: "Documents",
      caption: "AI for documents",
      chat: {
        title: "Chat",
        caption: "Interact",
      },
      documents: {
        title: "Documents",
        caption: "Repository",
      },
    },
    components: {
      title: "Components",
      caption: "Plumbing",
      demo: {
        title: "Demo Components",
        caption: "Demo",
      },
    },
    recruitment: {
      title: "Recruitment",
      caption: "Optimize your recruitments",
      positions: {
        title: "Positions",
        caption: "At your own pace",
      },
      candidates: {
        title: "Candidates",
        caption: "At your own pace",
      },
      calendar: {
        title: "Calendar Events",
        caption: "At your own pace",
      },
    },
    pipeline: {
      title: "Pipeline",
      caption: "AI pipeline monitoring",
      runs: {
        title: "Runs",
        caption: "Monitor pipeline runs",
      },
      llmPricing: {
        title: "LLM Pricing",
        caption: "Token pricing reference",
      },
      cost: {
        title: "Cost Dashboard",
        caption: "AI spend analytics",
      },
      seed: {
        reference: {
          success: "LLM model registry and pricing seeded successfully",
          error: "Failed to seed LLM model registry",
        },
      },
    },
    scholar: {
      title: "Scholar",
      caption: "AI-powered exam correction",
      sessions: {
        title: "Correction Sessions",
        caption: "Manage exam correction sessions",
      },
      prescribedWorks: {
        title: "Prescribed Works",
        caption: "Manage prescribed literary works",
      },
      evaluators: {
        title: "Evaluators",
        caption: "View evaluators",
      },
      agentDefinitions: {
        title: "AI Agents",
        caption: "Manage evaluation agent definitions",
      },
    },
    marketresearch: {
      title: "Market Research",
      caption: "AI-powered market quadrants",
      research: {
        title: "Markets",
        caption: "Map a market into a Gartner-style quadrant",
      },
    },
  },
};
